import List from "@mui/material/List";
import { ReactNode } from "react";

interface SidenavListProps {
  children: ReactNode;
}

function SidenavList({ children }: SidenavListProps) {
  return (
    <List
      sx={{
        px: 2,
        my: 0.3,
      }}
    >
      {children}
    </List>
  );
}

export default SidenavList;
